<template>
  <div class="article page-privacy box p-4" v-pre>
    <h1 class="border-bottom pb-2 mb-3">隐私权政策</h1>
    <p>一刻社区(<a href="http://yike.io">yike.io</a>)（下称本社区）所提供的服务，本社区非常尊重、也积极确保您的隐私权利不致受损，为了让您安心使用一刻的各项信息与服务，请于此前详读我们的隐私权政策（以下称本政策），我们将详尽说明如何搜集、处理与利用您的个人资料，以及其他隐私权相关内容。若您无法遵守或同意本政策全部或部分之条款，请立即停止使用一刻的所有服务。
    </p>
    <br>
    <p>一、适用范围</p>
    <p>本政策内容适用于本社区搜集、处理、利用与保护您在使用一刻相关服务时所取得的个人识别数据。</p>
    <br>
    <p>二、个人资料的搜集类型</p>
    <ol start="1">
      <li>
        您同意一刻搜集您注册、登录、发布讨论与评论等所留下的所有个人资料。包含但不限于：个人基本资料（如姓名、性别、出生日期、联络电话、居住地、联络地址、备用电子邮件信箱、职业等）、以及其它在本站产生的互动过程产生的相关数据（如手机号码、银行帐户号码、图片与其它媒体odmw、互动纪录等）、安全细节（如密码）、其他尚未归类之数据（如服务使用心得、使用数据等）。
      </li>
    </ol>
    <br>
    <ol start="2">
      <li>您同意本社区搜集您透过第三方网站或其他公司所提供的服务平台（如 Facebook 等），进行一刻之注册、登录、交易后，所产生如上述的数据。
      </li>
    </ol>
    <br>
    <p>三、个人资料的处理及利用方式</p>
    <ol start="1">
      <li>本社区将利用搜集之数据，致力提升您的服务体验，或作为开发新服务之用。包括但不限于：促销活动通知、调查统计等、服务更新通知等。
      </li>
    </ol>
    <br>
    <ol start="2">
      <li>本社区为配合当地法规与网站运作所需，数据亦将用于以下项目，包括但不限于：认证会员身份、社区发布的内容与其他商业行为、扣款通知、寄送发票与赠品、办理税务等。
      </li>
    </ol>
    <br>
    <ol start="3">
      <li>本社区搜集或利用之数据，将视业务所需与本社区的合作伙伴、跨平台服务（如 Facebook 等）共同进行，或于海外发生。若欲了解跨平台服务之中产生的数据搜集如何进行保护，请径洽各服务平台窗口。
      </li>
    </ol>
    <br>
    <ol start="4">
      <li>本社区不会未经您事先同意即将个人资料透露给无关之第三者。但若基于国家重大利益，或司法单位经合法程序要求本社区公开特定人数据者除外。
      </li>
    </ol>
    <br>
    <p>四、个人资料的保护</p>
    <ol start="1">
      <li>本社区所搜集之个人资料将尽力并妥善保存，服务中相关活动所产生的内容信息，均经使用安全的SSL加密协议处理，请您放心。
      </li>
    </ol>
    <br>
    <ol start="2">
      <li>一刻服务中均可能含有非本社区之第三方网页、服务等连接，若您同意该单位搜集您的个人资料，本社区无需负担任何连带责任。
      </li>
    </ol>
    <br>
    <p>五、个人资料的自主权</p>
    <ol start="1">
      <li>您注册并登录会员身份后，可以随时查询、修改、复制、删除您的个人帐号数据，若本社区无法确认您为本人，得以要求提供相关数据或书面数据等协助确认身份。
      </li>
    </ol>
    <br>
    <ol start="2">
      <li>若您成为一刻会员，即代表同意本社区所有隐私权政策，本社区毋需以任何管道另行征求您的同意。
      </li>
    </ol>
    <br>
    <ol start="3">
      <li>您本人可以要求本社区停止利用或删除您的个人资料，但一经停用或删除，即无法使用一刻所有服务。
      </li>
    </ol>
    <br>
    <ol start="4">
      <li>当违反国家重大利益、司法及公务机关或第三人重大利益时，本社区有权拒绝您变更、删除相关个人资料。
      </li>
    </ol>
    <br>
    <p>六、Cookie 的使用</p>
    <p>Cookie 为信息系统在您浏览或进行系统操作时，留存于您硬盘中的简短信息，纪录您于系统中进行的动作，以利提升您的服务体验。您可于浏览器中设定相关安全性，但若您限制或拒绝 Cookie，可能无法使用一刻部分服务。一刻之 Cookie 主要用于：</p>
    <br>
    <ol start="1">
      <li>会员登录相关认证。
      </li>
    </ol>
    <br>
    <ol start="2">
      <li>统计系统浏览量、用户操作等研究分析，予以提升系统服务体验。
      </li>
    </ol>
    <br>
    <ol start="3">
      <li>其他使用系统时需要纪录之信息。
      </li>
    </ol>
    <br>
    <p>七、隐私权保护政策之修正</p>
    <p>本社区将不定期修订本政策，依循并落实当地隐私权及个人资料保护等相关法令。若有重大政策变更，将以网站或搭配其他管道予以通知，本社区绝不会在您未明确同意时，损害您的权益。</p>
  </div>
</template>

<script>
export default {
  name: 'privacy'
}
</script>

<style scoped>
</style>
